import type { BrandKit, SobreimpresoPreset } from '@doer/frontend-components/creativity-editor';

const SOBREIMPRESO_PRESETS: SobreimpresoPreset[] = [
  {
    id: 'macro-azul-degradado',
    name: 'Azul degradado',
    config: {
      width: 480,
      height: 200,
      text: 'Macro',
      fill: {
        kind: 'linear',
        angle: 0,
        stops: [
          { offset: 0, color: 'rgba(0, 43, 218, 1)' }, // 002BDA @ 100%
          { offset: 1, color: 'rgba(199, 222, 254, 0.8)' } // C7DEFE @ 80%
        ]
      },
      textFill: '#FFFFFF',
      fontFamily: 'DM Sans',
      fontSize: 36,
      fontWeight: 700,
      borderRadius: 32,
      paddingX: 32,
      paddingY: 16
    }
  },
  {
    id: 'macro-transparente',
    name: 'Transparente',
    config: {
      width: 480,
      height: 250,
      text: 'Macro',
      fill: {
        kind: 'linear',
        angle: 0,
        stops: [
          { offset: 0, color: 'rgba(199, 222, 254, 0.8)' }, // C7DEFE @ 80%
          { offset: 1, color: 'rgba(255, 255, 255, 0.4)' } // FFFFFF @ 40%
        ]
      },
      textFill: '#002BDA',
      fontFamily: 'DM Sans',
      fontSize: 36,
      fontWeight: 700,
      borderRadius: 32,
      paddingX: 32,
      paddingY: 16
    }
  }
];

const COLORS: string[] = [
  '#00237C',
  '#0039E3',
  '#2D5FFF',
  '#5A89FF',
  '#CFE3FF',
  '#E9F3FF',
  '#343F49',
  '#FF7DCB',
  '#24BA4E',
  '#E7F2EB',
  '#EDEEEF',
  '#C9B787',
  '#846742',
  '#D8D7D6'
];

export const MACRO_BRAND_KIT: BrandKit = {
  sobreimpresoPresets: SOBREIMPRESO_PRESETS,
  colors: COLORS
};
